<div class="two-stage-brand-picker" (click)="onContainerClick($event)">
    <div class="selected-brand-container">
        @if (selectedBrand()) {
        <div class="brand-logo-chip" [class.pointer]="shouldAllowSelect" [matTooltip]="tooltipText"
            [matTooltipDisabled]="shouldAllowSelect">
            <img class="brand-logo" [src]="selectedBrand()!.icon" (error)="onImageError($event)" alt="Brand logo">
        </div>
        } @else {
        <div class="select-brand-wrapper">
            <div class="select-brand-container">
                <img [src]="'svg/big-plus.svg' | assetVersion" alt="Add brand icon">
            </div>
            <span class="select-brand-text">{{ placeholderText }}</span>
        </div>
        }
    </div>

    @if (selectedBrand()) {
    @if (hasNoCompetitors() || selectedCompetitors().length > 0) {
    <span class="vs-label" [class.grey]="!shouldAllowSelect">vs.</span>
    }
    <div class="competitors-container" [class.pointer]="shouldAllowSelect">
        @if (hasNoCompetitors()) {
        <span class="no-competitors-text">{{ NO_COMPETITORS_ASSIGNED }}</span>
        } @else if (selectedCompetitors().length > 0) {
        @for (competitor of selectedCompetitors().slice(0,maxCompetitors); track competitor.key) {
        <div class="brand-logo-chip" [class.pointer]="shouldAllowSelect" [matTooltip]="tooltipText"
            [matTooltipDisabled]="shouldAllowSelect">
            <img [src]="(competitor.icon || 'images/no-logo.png') | assetVersion" (error)="onImageError($event)" alt="">
        </div>
        }
        @if (selectedCompetitors().length > maxCompetitors) {
        <div class="brand-extra-chip">+{{ selectedCompetitors().length - maxCompetitors }}</div>
        }
        }
    </div>
    }

    @if (shouldAllowSelect){
    <app-select-menu [items]="brandOptions()" [control]="brandControl" [selectMode]="SelectMode.ATTACHED_SINGLE"
        [hideSelected]="false" [searchable]="brandOptions().length > 6" [openPanel]="isPanelOpen"
        [dropDownPosition]="'bottom'" [limitedHeight]="true" (onApply)="onBrandSelected($event)">
    </app-select-menu>

    @if (selectedBrand() && competitorOptions().length > 0) {
    <app-select-menu #competitorSelectMenu [items]="competitorOptions()" [control]="competitorControl"
        [selectMode]="SelectMode.MULTI" [hideSelected]="true" [searchable]="competitorOptions().length > 6"
        [openPanel]="isCompetitorPanelOpen" [dropDownPosition]="'bottom'" [width]="'250px'"
        [selectAllAndClearOptions]="true" [customHeaderTemplate]="brandHeaderTemplate" [limitedHeight]="true"
        class="competitor-select-menu" (onApply)="onCompetitorsSelected($event)">
    </app-select-menu>
    }

    @if (selectedBrand()) {
    <div class="reset-button" (click)="onReset($event)">
        <img [src]="'svg/big-plus.svg' | assetVersion" class="clean-icon" alt="">
    </div>
    }
    }
</div>

<ng-template #brandHeaderTemplate>
    <div class="brand-header-option" (click)="onBackToBrands($event)">
        <div class="back-arrow">
            <img [src]="'svg/arrow-left.svg' | assetVersion" alt="Back arrow">
        </div>
        <img class="icon" [src]="selectedBrand()!.icon | assetVersion" (error)="onImageError($event)" alt="Brand logo">
        <span>{{ selectedBrand()?.label }}</span>
    </div>
    @if (competitorSelectionText) {
        <div class="competitor-selection-text">{{ competitorSelectionText }}</div>
    }
</ng-template>